import { __ } from '@wordpress/i18n';
import { registerBlockVariation } from '@wordpress/blocks';

const VARIATION_NAME = 'museuio-companion/exhibition-list';

// wp.blocks.updateCategory( 'museuio-companion', {  } );
// console.log('will register variation')
registerBlockVariation( 'core/query', {
    name: VARIATION_NAME,
    title: __('Exhibition List', 'museuio-companion'),
    description: __('Displays a list of exhibitions', 'museuio-companion'),
    category: "museuio-companion",
    scope: [ 'inserter' ],
    allowedControls: [ 'inherit', 'taxQuery', 'search', 'order', 'sticky' ], // 'order', 

    isActive: ( { namespace, query } ) => {
        return (
            namespace === VARIATION_NAME
            && query.postType === 'mio_exhibition'
        );
    },

    attributes: {
        namespace: VARIATION_NAME,
        query: {
            postType: 'mio_exhibition',
            perPage: 4,
            pages: 0,
            offset: 0,
            order: 'desc',
            orderBy: 'date',
            author: '',
            search: '',
            exclude: [],
            sticky: '',
            inherit: false,
            mioExhibitionDateFilter: 'all',
            mioOnShowIncludeFuture: false
        },
        // enhancedPagination: true
    },

    innerBlocks: [
        [
            'core/post-template',
            {"layout":{"type":"grid","columnCount":4}},
            [ 
                [ 'core/post-featured-image' ], 
                [ 'core/post-title' ], 
                [ 'museuio-companion/exhibition-date' ], 
                [ 'core/post-excerpt' ] 
            ],
        ],
        [ 'core/query-pagination' ],
        [ 'core/query-no-results' ],
    ],

} );